/**
 * admin 相关存储信息
 *   classes        班级列表
 *   userType       用户类型
 */

import axios from 'assets/js/myAxios'

let userTypes = [{
  text: '测试账户',
  value: 1
}, {
  text: '体验账户',
  value: 2
}, {
  text: '付费账户',
  value: 3
}, {
  text: '推广账户',
  value: 4
}, {
  text: '智能账户',
  value: 5
}]

const admin = {
  state: {
    classes: [],
    userTypes
  },
  mutations: {
    SET_CLASSES: (state, data) => {
      state.classes = data
    }
  },
  actions: {
    getClasses ({ commit }) {
      return new Promise((resolve, reject) => {
        axios.get('admin/class?orderby=&dir=asc')
          .then(response => {
            commit('SET_CLASSES', response)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    }
  }
}

export default admin



// WEBPACK FOOTER //
// ./src/store/modules/admin.js